import React, { useEffect } from 'react';
import { Drawer } from 'antd';

function DrawerBox(props) {
  const { title, visible, setVisible, width, placement, footer, closeVisible, height, className, bodyStyle, headerSyle, footerSyle } = props;

  const onClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    const body = document.querySelector('body');
    if (visible) {
      return (body.style.overflowY = 'hidden');
    }
    return () => {
      return (body.style.overflowY = 'unset');
    };
  }, [visible]);

  return (
    <Drawer
      closable={closeVisible}
      height={height || '100vh'}
      title={title}
      onClose={onClose}
      visible={visible}
      className={className}
      width={width}
      placement={placement || 'right'}
      footer={footer || null}
      bodyStyle={bodyStyle}
      headerSyle={headerSyle}
      footerStyle={footerSyle}
    >
      {props.children}
    </Drawer>
  );
}

export default DrawerBox;
